import { LOADING_STAGES, LIST_STAGES } from "../../constants/types";
import {
  ADD_REVIEW_STAGE,
  REMOVE_REVIEW_STAGE,
  UPDATE_REVIEW_STAGE,
  REORDER_REVIEW_STAGES,
  SET_REVIEW_STAGE_STATUS,
  RESET_REVIEW_STAGES,
} from "../actions/reviewStagesActions";
import { Nullable } from "../../types/common";
import { IReviewStage } from "../../types/review-stage/ireview-stage.interface";

export interface IReviewStageState {
  reviewStages: ReviewStagesState;
}

export interface ReviewStagesState {
  loading: boolean;
  count: number;
  next: Nullable<number>;
  previous: Nullable<number>;
  stages: IReviewStage[];
}
const initialState: ReviewStagesState = {
  loading: false,
  count: 0,
  next: null,
  previous: null,
  stages: [],
};

const reviewStagesReducer = (state = initialState, action: any) => {
  const { stages, stage, stageId, orderedStageIds, status } = action.payload || {};
  switch (action.type) {
    case LOADING_STAGES:
      return {
        ...state,
        loading: true,
      };
    case LIST_STAGES:
      return {
        ...state,
        loading: false,
        stages,
      };
    case ADD_REVIEW_STAGE:
      return {
        ...state,
        loading: false,
        stages: state.stages.concat(stage),
      };
    case REMOVE_REVIEW_STAGE:
      return {
        ...state,
        stages: state.stages.filter(({ id }) => id !== stageId),
      };
    case UPDATE_REVIEW_STAGE:
      return {
        ...state,
        stages: state.stages.map((result) => (result.id === stage.id ? stage : result)),
      };
    case REORDER_REVIEW_STAGES:
      return {
        ...state,
        stages: [...state.stages].sort(
          (a, b) => orderedStageIds.indexOf(a.id) - orderedStageIds.indexOf(b.id)
        ),
      };
    case SET_REVIEW_STAGE_STATUS:
      return {
        ...state,
        stages: state.stages.map((stage) => (stage.id === stageId ? { ...stage, status } : stage)),
      };
    case RESET_REVIEW_STAGES:
      return initialState;
    default:
      return state;
  }
};

export default reviewStagesReducer;
